import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { Beneficiary } from './Beneficiary';

@supertypeClass({ toClient: true, toServer: true })
export class UniversalBeneficiary extends Everything {
  @property()
  beneficiary: Beneficiary;

  @property()
  type: string;

  constructor() {
    super();
  }

  static new(beneficiary: Beneficiary, type: string): UniversalBeneficiary {
    return new UniversalBeneficiary().init(beneficiary, type);
  }

  init(beneficiary: Beneficiary, type: string): this {
    this.beneficiary = beneficiary;
    this.type = type;
    return this;
  }

  getBeneficiaryType(): string {
    if (!this.beneficiary.policy) {
      return;
    } else {
      if (this.type === 'primary') {
        return this.beneficiary.policy.beneficiaryType === '13'
          ? this.beneficiary.policy.beneficiaryChildrenType
          : this.beneficiary.policy.beneficiaryType;
      } else {
        return this.beneficiary.policy.contingentBeneficiaryType === '13'
          ? this.beneficiary.policy.contingentBeneficiaryChildrenType
          : this.beneficiary.policy.contingentBeneficiaryType;
      }
    }
  }

  getNameOfOtherParent(): string {
    if (this.getBeneficiaryType() === '12') {
      return this.type === 'primary'
        ? this.beneficiary.policy.beneficiaryOtherParentName
        : this.beneficiary.policy.contingentBeneficiaryOtherParentName;
    } else {
      return '';
    }
  }

  getBeneficiaryRelationship(): string {
    const beneType = this.getBeneficiaryType(),
      spouseType = '9';

    if (beneType === spouseType) {
      if (this.beneficiary.policy.ownerType === 'partnerfiance') {
        return 'Partner/Fiance';
      } else {
        return 'Spouse';
      }
    } else {
      return this.beneficiary.relationship;
    }
  }
}
